// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.muutoshakemus-paatos__content {
  width: 100%;
  max-width: 1000px;
  padding: 2rem;
  box-sizing: border-box;
}
.muutoshakemus-paatos__header {
  display: flex;
  justify-content: space-between;
  width: 100%;
  font-size: 1.2rem;
  text-transform: uppercase;
  padding: 10px 0 30px;
  text-align: center;
}
.muutoshakemus-paatos-title {
  text-align: left;
}
.muutoshakemus-paatos__org {
  font-size: 1.8rem;
  letter-spacing: -0.015em;
  font-weight: bold;
}
.muutoshakemus-paatos__section {
  display: flex;
  padding: 3rem 0;
}
.muutoshakemus-paatos__section:not(.no-border-top) {
  border-top: 1px solid #d9d9d9;
}
.muutoshakemus-paatos__section-paatos {
  flex-direction: column;
}
.muutoshakemus-paatos__section-container {
  display: flex;
  width: 100%;
}
.muutoshakemus-paatos__section-content {
  width: 100%;
}
.muutoshakemus-paatos__title {
  width: 20%;
  min-width: 20%;
  margin-right: 2rem;
}
.muutoshakemus-paatos__perustelut div:nth-child(2) {
  margin-top: 1rem;
}
.muutoshakemus-paatos__project-name {
  padding-bottom: 1.2rem;
  font-size: 1.2rem;
  letter-spacing: -0.015em;
  font-weight: bold;
}
.muutoshakemus-paatos__project-name > i {
  font-style: normal;
}
.muutoshakemus-paatos__jatkoaika {
  display: flex;
  margin-bottom: 2rem;
}
.muutoshakemus-paatos__jatkoaika div {
  margin-right: 4rem;
}
.muutoshakemus-paatos__talousarvio {
  margin-bottom: 2rem;
}
.muutoshakemus-paatos__change-header {
  font-weight: 600;
  font-size: 1rem;
  color: black;
  margin: 0 0 1.2rem;
}
.muutoshakemus-paatos__presenter {
  margin-top: 1.2rem;
}
.muutoshakemus-paatos__reason {
  white-space: pre-wrap;
}
`, "",{"version":3,"sources":["webpack://./soresu-form/web/va/MuutoshakemusPaatos.less"],"names":[],"mappings":"AAAA;EACE,WAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;AACF;AAEA;EACE,aAAA;EACA,8BAAA;EACA,WAAA;EACA,iBAAA;EACA,yBAAA;EACA,oBAAA;EACA,kBAAA;AAAF;AAGA;EACE,gBAAA;AADF;AAIA;EACE,iBAAA;EACA,wBAAA;EACA,iBAAA;AAFF;AAKA;EACE,aAAA;EACA,eAAA;AAHF;AAKE;EACE,6BAAA;AAHJ;AAME;EACE,sBAAA;AAJJ;AAOE;EACE,aAAA;EACA,WAAA;AALJ;AAQE;EACE,WAAA;AANJ;AAUA;EACE,UAAA;EACA,cAAA;EACA,kBAAA;AARF;AAWA;EACE,gBAAA;AATF;AAYA;EACE,sBAAA;EACA,iBAAA;EACA,wBAAA;EACA,iBAAA;AAVF;AAMA;EAOI,kBAAA;AAVJ;AAcA;EACE,aAAA;EACA,mBAAA;AAZF;AAUA;EAKI,kBAAA;AAZJ;AAgBA;EACE,mBAAA;AAdF;AAiBA;EACE,gBAAA;EACA,eAAA;EACA,YAAA;EACA,kBAAA;AAfF;AAkBA;EACE,kBAAA;AAhBF;AAmBA;EACE,qBAAA;AAjBF","sourcesContent":[".muutoshakemus-paatos__content {\n  width: 100%;\n  max-width: 1000px;\n  padding: 2rem;\n  box-sizing: border-box;\n}\n\n.muutoshakemus-paatos__header {\n  display: flex;\n  justify-content: space-between;\n  width: 100%;\n  font-size: 1.2rem;\n  text-transform: uppercase;\n  padding: 10px 0 30px;\n  text-align: center;\n}\n\n.muutoshakemus-paatos-title {\n  text-align: left;\n}\n\n.muutoshakemus-paatos__org {\n  font-size: 1.8rem;\n  letter-spacing: -0.015em;\n  font-weight: bold;\n}\n\n.muutoshakemus-paatos__section {\n  display: flex;\n  padding: 3rem 0;\n\n  &:not(.no-border-top) {\n    border-top: 1px solid #d9d9d9;\n  }\n\n  &-paatos {\n    flex-direction: column;\n  }\n\n  &-container {\n    display: flex;\n    width: 100%;\n  }\n\n  &-content {\n    width: 100%;\n  }\n}\n\n.muutoshakemus-paatos__title {\n  width: 20%;\n  min-width: 20%;\n  margin-right: 2rem;\n}\n\n.muutoshakemus-paatos__perustelut div:nth-child(2) {\n  margin-top: 1rem;\n}\n\n.muutoshakemus-paatos__project-name {\n  padding-bottom: 1.2rem;\n  font-size: 1.2rem;\n  letter-spacing: -0.015em;\n  font-weight: bold;\n\n  > i {\n    font-style: normal;\n  }\n}\n\n.muutoshakemus-paatos__jatkoaika {\n  display: flex;\n  margin-bottom: 2rem;\n\n  div {\n    margin-right: 4rem;\n  }\n}\n\n.muutoshakemus-paatos__talousarvio {\n  margin-bottom: 2rem;\n}\n\n.muutoshakemus-paatos__change-header {\n  font-weight: 600;\n  font-size: 1rem;\n  color: black;\n  margin: 0 0 1.2rem;\n}\n\n.muutoshakemus-paatos__presenter {\n  margin-top: 1.2rem;\n}\n\n.muutoshakemus-paatos__reason {\n  white-space: pre-wrap;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
